import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import truncateText from '../utils/truncateText';

const MovieComponent = ({
  title,
  description,
  imageUrl,
  rating,
  isDarkTheme,
  viewMoreUrl,
  publicationDate,
}) => {
  return (
    <div
      className={classNames(
        'p-6 rounded-lg text-left movie-container overflow-hidden flex flex-col',
        { 'bg-gray-100': !isDarkTheme },
        { 'bg-gray-800 bg-opacity-40': isDarkTheme },
      )}
    >
      <img
        className="h-40 rounded w-full object-cover object-center mb-6"
        src={imageUrl}
        alt="content"
      />
      <h2
        className={classNames(
          'tracking-widest text-xs font-medium title-font',
          { 'text-blue-800': !isDarkTheme },
          { 'text-indigo-400': isDarkTheme },
        )}
      >
        <span className="after-separator">Drama</span>
        {rating && <span className="after-separator">{rating}</span>}
      </h2>
      <h2
        className={classNames(
          'text-lg font-medium title-font mb-4',
          { 'text-gray-900': !isDarkTheme },
          { 'text-white': isDarkTheme },
        )}
      >
        {truncateText(title, 25, '...')}
      </h2>
      <p className="leading-relaxed text-base">{truncateText(description, 100, '...')}</p>
      <p
        className={classNames(
          'leading-relaxed text-base',
          { 'text-gray-900': !isDarkTheme },
          { 'text-white': isDarkTheme },
        )}
      >
        {`Date: ${
          publicationDate ? new Date(publicationDate).toDateString() : new Date().toDateString()
        }`}
      </p>
      {viewMoreUrl && (
        <a
          href={viewMoreUrl}
          className={classNames(
            'flex justify-center items-center py-2 mt-auto',
            { 'text-blue-800': !isDarkTheme },
            { 'text-indigo-400': isDarkTheme },
          )}
          aria-label={`View More about Review of ${title}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          View More
          <svg
            className="w-4 h-4 ml-2"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="M12 5l7 7-7 7" />
          </svg>
        </a>
      )}
    </div>
  );
};

MovieComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  viewMoreUrl: PropTypes.string,
  rating: PropTypes.string,
  isDarkTheme: PropTypes.bool,
  publicationDate: PropTypes.string,
};

export default MovieComponent;
